<div *ngIf="showLoader">
    <app-loader></app-loader>
</div>

<app-drawer [isModal]='true' [drawerId]="'ProccedMessageDrawer'" [width]="'half'" class="call-popup"
    [backdropDisable]="true">
    <div class="popup-container">
        <div class="close-icon-popup">
            <img (click)="hideDrawer('ProccedMessageDrawer')" src="assets/img/svg/close.svg" alt="close-icon">
        </div>
        <h5 class="text-center thankyou-msg-popup">{{ errorTitle || 'Unable to Retrive Vehicle Details' }}</h5>
        <div class="text-center call-img-popup">
            <img src="assets/img/svg/thankYouImage.svg" height="50%" width="50%" alt="thankyou header">
        </div>
        <div class="text-center msg-2-popup padding-bt">
            {{ errorMessage || 'We couldn\'t fetch the details for the provided registration number. Please verify the number and try again.' }}
        </div>
        <div class="text-center">
            <button (click)="hideDrawer('ProccedMessageDrawer')"
                class=" text-center btn btn-primary btnconfirm btn-single btn-margin" type="button">
                CLOSE
            </button>
        </div>
    </div>
</app-drawer>